import ComponentFlipclock from 'components/Flipclock'
import { chain } from 'ramda'
import * as React from 'react'
import { connect } from 'react-redux'
import { AppState } from '../data/state'

interface FlipProps {
  timestamp: string | Date
  defaultContent: any
  loading: boolean

  onTick?(value: number): void

  onZero?(): void
}

const Flipclock: React.FC<FlipProps> = props => {
  const { defaultContent, loading } = props

  function getTextOrDefault(
    key: string,
    placeholder: string,
    plural?: boolean,
  ) {
    return defaultContent[key]
      ? plural
        ? defaultContent[key].plural
        : defaultContent[key].singular
      : placeholder
  }

  const keys = [
    'year',
    'month',
    'week',
    'day',
    'hour',
    'minute',
    'second',
    'milisecond',
  ]
  const locale = chain(
    key => [
      { key, plural: false },
      { key, plural: true },
    ],
    keys,
  ).reduce((acc, { key, plural }) => {
    const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)
    const placeholder = capitalize(key) + (plural ? 's' : '')
    const newKey = key.toUpperCase() + '_' + (plural ? 'PLURAL' : 'SINGULAR')
    return { ...acc, [newKey]: getTextOrDefault(key, placeholder, plural) }
  }, {})

  return (
    <ComponentFlipclock
      show={!loading}
      timestamp={props.timestamp}
      onTick={props.onTick}
      onZero={props.onZero}
      locale={locale}
    />
  )
}

export default connect((state: AppState) => ({
  defaultContent: state.contentEngine.defaultContent,
  loading: state.contentEngine.loading,
}))(Flipclock)
